import { useFormContext, UseFormReturn } from 'react-hook-form';

import { AppError } from '@/utils';

import { AddUserForm } from './use-add-user.form';

export const useAddUserFormContext = (): UseFormReturn<AddUserForm> | never => {
  const form = useFormContext<AddUserForm>();

  if (form === null)
    throw AppError.hookScopeError('useAddUserFormContext error.');

  return form;
};
